function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-1{fill:var(--dark);stroke:var(--dark);stroke-width:.2px}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "prefix__clipboard_1_",
  "data-name": "clipboard (1)",
  transform: "translate(-46.937 .101)"
}, /*#__PURE__*/React.createElement("g", {
  id: "prefix__Group_62",
  "data-name": "Group 62",
  transform: "translate(47.037)"
}, /*#__PURE__*/React.createElement("g", {
  id: "prefix__Group_61",
  "data-name": "Group 61"
}, /*#__PURE__*/React.createElement("path", {
  id: "prefix__Path_238",
  d: "M65.364 3.5h-2.418V2.42c0-.35-.382-.509-.732-.509h-1.877A2.846 2.846 0 0 0 57.505 0a2.9 2.9 0 0 0-2.832 1.909h-1.845c-.35 0-.7.159-.7.509V3.5H49.71a2.7 2.7 0 0 0-2.673 2.577v18.234a2.56 2.56 0 0 0 2.673 2.418h15.654a2.56 2.56 0 0 0 2.673-2.418V6.08a2.7 2.7 0 0 0-2.673-2.58zM53.4 3.184h1.75a.7.7 0 0 0 .6-.573 1.845 1.845 0 0 1 1.75-1.432 1.814 1.814 0 0 1 1.718 1.432.7.7 0 0 0 .636.573h1.814V5.73H53.4zm13.364 21.127a1.291 1.291 0 0 1-1.4 1.145H49.71a1.291 1.291 0 0 1-1.4-1.145V6.08a1.432 1.432 0 0 1 1.4-1.3h2.418V6.4a.668.668 0 0 0 .7.6h9.386a.7.7 0 0 0 .732-.6V4.775h2.418a1.432 1.432 0 0 1 1.4 1.3v18.236z",
  className: "prefix__cls-1",
  "data-name": "Path 238",
  transform: "translate(-47.037)"
}), /*#__PURE__*/React.createElement("path", {
  id: "prefix__Path_239",
  d: "M104.243 230.51a.636.636 0 0 0-.891-.032l-2.036 1.941-.859-.891a.636.636 0 0 0-.891-.032.668.668 0 0 0 0 .923l1.3 1.336a.573.573 0 0 0 .445.191.636.636 0 0 0 .445-.191l2.482-2.355a.6.6 0 0 0 .037-.854c-.007-.012-.019-.024-.032-.036z",
  className: "prefix__cls-1",
  "data-name": "Path 239",
  transform: "translate(-96.193 -216.285)"
}), /*#__PURE__*/React.createElement("path", {
  id: "prefix__Path_240",
  d: "M206.5 256.034h-7.318a.636.636 0 1 0 0 1.273h7.318a.636.636 0 1 0 0-1.273z",
  className: "prefix__cls-1",
  "data-name": "Path 240",
  transform: "translate(-189.321 -240.441)"
}), /*#__PURE__*/React.createElement("path", {
  id: "prefix__Path_241",
  d: "M104.243 146.918a.636.636 0 0 0-.891-.032l-2.036 1.941-.859-.891a.636.636 0 0 0-.891-.032.668.668 0 0 0 0 .923l1.3 1.336a.573.573 0 0 0 .445.191.637.637 0 0 0 .445-.191l2.482-2.355a.6.6 0 0 0 .037-.854.517.517 0 0 0-.032-.036z",
  className: "prefix__cls-1",
  "data-name": "Path 241",
  transform: "translate(-96.193 -137.784)"
}), /*#__PURE__*/React.createElement("path", {
  id: "prefix__Path_242",
  d: "M206.5 172.442h-7.318a.636.636 0 1 0 0 1.273h7.318a.636.636 0 1 0 0-1.273z",
  className: "prefix__cls-1",
  "data-name": "Path 242",
  transform: "translate(-189.321 -161.94)"
}), /*#__PURE__*/React.createElement("path", {
  id: "prefix__Path_243",
  d: "M104.243 314.1a.636.636 0 0 0-.891-.032l-2.036 1.941-.859-.891a.636.636 0 0 0-.891-.032.668.668 0 0 0 0 .923l1.3 1.337a.573.573 0 0 0 .445.191.636.636 0 0 0 .445-.191l2.482-2.355a.6.6 0 0 0 .037-.854c-.007-.012-.019-.024-.032-.037z",
  className: "prefix__cls-1",
  "data-name": "Path 243",
  transform: "translate(-96.193 -294.785)"
}), /*#__PURE__*/React.createElement("path", {
  id: "prefix__Path_244",
  d: "M206.5 339.626h-7.318a.636.636 0 1 0 0 1.273h7.318a.636.636 0 1 0 0-1.273z",
  className: "prefix__cls-1",
  "data-name": "Path 244",
  transform: "translate(-189.321 -318.942)"
}))));

var SvgClaimsIcon = function SvgClaimsIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21.2,
    height: 26.93,
    viewBox: "0 0 21.2 26.93",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClaimsIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/claims-icon.acc8a3af.svg";
export { ForwardRef as ReactComponent };